module.exports = __webpack_public_path__ + "static/media/GEIST.87f1893c.svg";